const sidebar = {
  groupCore: "ליבה",
  groupTools: "כלים",
  groupSystem: "מערכת",
  filterMe: "Me",
  filterTeam: "Team",
  filterHidden: "Hide",
  filterFavorites: "Favorites",
  viewList: "רשימה",
  viewGrid: "רשת",
  viewCompact: "מצומצם",
  viewFolders: "תיקיות",
  viewFlat: "שטוח",
  editMode: "עריכת סידור",
  doneEditing: "סיום",
  autoSort: "מיון לפי שימוש",
  resetOrder: "אפס סידור",
  resetConfirm: "לאפס את כל ההתאמות?",
  hide: "הסתר",
  show: "הצג",
  openNewTab: "פתח בלשונית חדשה",
  addFav: "הוסף למועדפים",
  removeFav: "הסר ממועדפים",
  moveToFolder: "העבר לתיקייה...",
  newFolder: "תיקייה חדשה...",
  removeFromFolder: "הסר מתיקייה",
  folderName: "שם תיקייה",
  addNote: "הוסף פתקית",
  editNote: "ערוך פתקית",
  hiddenCount: "פריטים מוסתרים",
  itemEdit: "עריכת לשונית",
  customLabel: "כינוי מותאם",
  language: "שפת תצוגה",
  iconPosition: "מיקום אייקון",
  changeIcon: "שנה אייקון",
  resetItem: "אפס לשונית",
  langHe: "עברית",
  langEn: "English",
  langRu: "Русский",
  langCustom: "מותאם",
  posStart: "התחלה",
  posEnd: "סוף",
  posAbove: "מעל",
  addSection: "הוסף מקטע",
  newSectionName: "שם המקטע...",
  deleteSection: "מחק מקטע",
  // App folders (tag-based, multi-membership, persisted to Supabase)
  appFolders: "תיקיות אפליקציות",
  allApps: "כל האפליקציות",
  newAppFolder: "תיקייה חדשה",
  appFolderNamePlaceholder: "שם התיקייה...",
  createFirstFolder: "צור תיקייה ראשונה",
  addToFolders: "הוסף לתיקיות",
  inNFolders: "ב-{count} תיקיות",
  manageFolders: "ניהול תיקיות",
  navItemsSection: "פריטי תפריט ניווט",
  deleteFolderConfirm: 'למחוק את התיקייה "{name}"?',
} as const;
export default sidebar;
